<template>
  <div class="user-detail-container">
    <div class="page-header">
      <div class="page-title-block">
        <h2>用户详情</h2>
        <p class="page-subtitle">查看单个员工的基础信息与归属部门</p>
      </div>
      <div class="header-actions">
        <el-button @click="$router.back()">返回</el-button>
        <el-button type="primary" @click="handleEdit" :disabled="!user">
          <i class="el-icon-edit"></i> 编辑用户
        </el-button>
      </div>
    </div>

    <el-card v-loading="loading" class="user-card" v-if="user">
      <div class="user-header">
        <div class="avatar-circle">
          <span>{{ user.name ? user.name.charAt(0) : '用' }}</span>
        </div>
        <div class="user-basic">
          <h3>{{ user.name || '-' }}</h3>
          <p class="username">
            <i class="el-icon-user"></i>
            {{ user.username || '-' }}
          </p>
          <el-tag size="mini" type="success" v-if="user.department && user.department.name">
            {{ user.department.name }}
          </el-tag>
        </div>
      </div>

      <el-divider></el-divider>

      <div class="user-info-grid">
        <div class="info-item">
          <label>手机号</label>
          <span>{{ user.phone || '-' }}</span>
        </div>
        <div class="info-item">
          <label>邮箱</label>
          <span>{{ user.email || '-' }}</span>
        </div>
        <div class="info-item">
          <label>部门</label>
          <span>{{ (user.department && user.department.name) || '-' }}</span>
        </div>
        <div class="info-item">
          <label>账户名</label>
          <span>{{ user.username || '-' }}</span>
        </div>
      </div>
    </el-card>

    <el-empty v-else-if="!loading" description="未找到该用户"></el-empty>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'UserDetail',
  data() {
    return {
      loading: false,
      user: null
    }
  },
  computed: {
    userId() {
      return parseInt(this.$route.params.id)
    }
  },
  mounted() {
    this.loadUser()
  },
  methods: {
    loadUser() {
      if (!this.userId) return
      this.loading = true
      request.get(`/users/${this.userId}`)
        .then(res => {
          this.user = res.data || res
        })
        .catch(err => {
          console.error('加载用户详情失败:', err)
          this.$message.error('加载用户详情失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleEdit() {
      if (!this.userId) return
      this.$router.push(`/users`) // 回到列表后可以在列表里编辑
    }
  }
}
</script>

<style scoped>
.user-detail-container {
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding: 10px 4px 4px;
}

.page-title-block h2 {
  margin: 0;
  color: #0f8f59;
  font-size: 22px;
}

.page-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.user-card {
  border-radius: 14px;
  box-shadow: 0 14px 32px rgba(15, 143, 89, 0.08);
}

.user-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.avatar-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-image: linear-gradient(135deg, #17b676, #0f9bd7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}

.user-basic h3 {
  margin: 0 0 4px;
  font-size: 20px;
}

.username {
  margin: 0 0 4px;
  font-size: 13px;
  color: #80848f;
}

.username i {
  margin-right: 4px;
}

.user-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item label {
  font-size: 12px;
  color: #909399;
}

.info-item span {
  font-size: 14px;
  color: #303133;
}

@media (max-width: 768px) {
  .user-detail-container {
    padding: 0 4px;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .header-actions {
    justify-content: flex-end;
  }
}
</style>

